import { render, staticRenderFns } from "./Contentmanagement.vue?vue&type=template&id=59b86f2a"
import script from "./Contentmanagement.vue?vue&type=script&lang=js"
export * from "./Contentmanagement.vue?vue&type=script&lang=js"
import style0 from "./Contentmanagement.vue?vue&type=style&index=0&id=59b86f2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports